// 员工
import * as type from "../mutation-types"
const state = {
  data:window.localStorage.getItem("staffType") || ""
}

const getters = {
  getStaffType:state=>state.data
}

const mutations = {
  [type.USER_OUT_LOGIN](state){
    state.data = null
  }
}

const actions = {
  onUse(response){
    window.localStorage.setItem("staffType",response)
  },
  outLogin({commit}){
    commit(type.USER_OUT_LOGIN)
    window.localStorage.removeItem("staffType")
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
